import styled from 'styled-components';

export const Discount = styled.div`
  width: 75px;
  opacity: 0.9;
  height: 26px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.T400};
  color: ${({ theme }) => theme.palette.NL0};

  text-align: center;
  font-weight: 600;
  font-size: 12px;
  border-radius: 8px;
  white-space: nowrap;
  justify-content: center;
`;
